import { render, staticRenderFns } from "./selectMultiPro.vue?vue&type=template&id=c775c4d2&scoped=true"
import script from "./selectMultiPro.vue?vue&type=script&lang=js"
export * from "./selectMultiPro.vue?vue&type=script&lang=js"
import style0 from "./selectMultiPro.vue?vue&type=style&index=0&id=c775c4d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c775c4d2",
  null
  
)

export default component.exports